import { render, staticRenderFns } from "./payRecordList.vue?vue&type=template&id=002418b4&"
import script from "./payRecordList.vue?vue&type=script&lang=js&"
export * from "./payRecordList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports